import React, { useEffect, useState } from "react";
import "./About.css";
import API from "../api/Api";

const AboutPortalHero = () => {
  const [header, setHeader] = useState({
    title: "",
    description: ""
  });

  useEffect(() => {
    const fetchHeader = async () => {
      try {
        const response = await API.get("/about_header");

        if (response.data?.data?.length > 0) {
          setHeader(response.data.data[0]);
        }

        console.log("Fetched portal header:", response.data.data[0]);
      } catch (error) {
        console.error("Error fetching portal header:", error);
      }
    };

    fetchHeader();
  }, []);

  return (
    <section className="about-portal-hero">
      <div className="container">
        <div className="about-portal-content">

          {/* <h6 className="about-portal-badge">About the Portal</h6> */}

          <h1 className="about-portal-title">
            {header.title || "Maharashtra Portal for Corporate"}
          </h1>

          <p className="about-portal-subtitle">
            {header.description}
          </p>

        </div>
      </div>
    </section>
  );
};

export default AboutPortalHero;
